<button [buttonStyle]="'button-1'"
        (click)="showApp()"
        [class._is-disabled]="isDisabled"
        class="w-12 p-r-0-s p-l-0-s">
    {{ (project ? 'edit design' : 'customize design') | translate }}
</button>